
import { Vue, Component, Watch } from "vue-property-decorator";
// import { getInfo } from "@/apis/about";
import ApplyFormDialog from "@/components/ApplyFormDialog.vue";
@Component({
  components: { ApplyFormDialog }
})
export default class Layout extends Vue {
  //

  info = {
    wechat: "",
    tel: ""
  };
  activeIndex = "/";

  show: boolean = false;

  created() {
    // this.getInfo();
  }
  handleSelect(key: any, keyPath: any) {
    console.log(key, keyPath);
  }

  // 获取电话及微信
  // async getInfo() {
  //   const data = await getInfo();
  //   this.info = data;
  // }

  backToScrollBottom() {
    const timer = setInterval(() => {
      let currentPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= 30;
      if (currentPosition > 0) {
        window.scrollTo(0, currentPosition);
      } else {
        window.scrollTo(0, 0);
        clearInterval(timer);
      }
    }, 1);
  }
}
